import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import {
  BreadcrumbModule,
  EmptyStateModule,
  LoaderModule,
  LogoModule,
  ModalModule,
  PaginatorModule,
  ScrollbarModule,
  StatusModule,
  TableModule
} from '@michelin/theme';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { UserGroupComponent } from './components/user-group/user-group.component';
import { UserSetupComponent } from './components/user-setup/user-setup.component';
import { GroupComponent } from './components/user/group.component';
import { UserComponent } from './components/user/user.component';
import { SharedModule } from '../../shared/shared.module';
import { SelectCustomerComponent } from './components/select-customer/select-customer.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    LogoModule,
    FormsModule,
    MatButtonModule,
    MatSelectModule,
    MatOptionModule,
    ReactiveFormsModule,
    LoaderModule,
    BreadcrumbModule,
    EmptyStateModule,
    StatusModule,
    TableModule,
    PaginatorModule,
    ModalModule,
    ScrollbarModule,
    SharedModule
  ],
  declarations: [
    ChangePasswordComponent,
    UserSetupComponent,
    UserComponent,
    UserInfoComponent,
    UserGroupComponent,
    GroupComponent,
    SelectCustomerComponent
  ],
  exports: [ChangePasswordComponent, UserSetupComponent, UserComponent, GroupComponent, UserGroupComponent, SelectCustomerComponent]
})
export class UserManagementModule {}
